import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import 'ant-design-vue/dist/reset.css'
import 'vue-cropper/dist/index.css'

const app = createApp(App)
const pinia = createPinia()

app.use(Antd)
app.use(router)
app.use(pinia)

app.mount('#app') 